import { render, staticRenderFns } from "./SecureUploadView.vue?vue&type=template&id=536fd782"
import script from "./SecureUploadView.vue?vue&type=script&lang=js"
export * from "./SecureUploadView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports